// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__2PM5_","obliqueLineWrap":"membershipbadge_obliqueLineWrap__dLh7h","obliqueLine":"membershipbadge_obliqueLine__3UylR"};